import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgLy = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="flag-icons-ly"
    viewBox="0 0 640 480"
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <clipPath id="ly-a">
        <path d="M166.7-20h666.6v500H166.7z" />
      </clipPath>
    </defs>
    <g clipPath="url(#ly-a)" transform="matrix(.96 0 0 .96 -160 19.2)">
      <path fill="#239e46" d="M0-20h1000v500H0z" />
      <path fill="#000001" d="M0-20h1000v375H0z" />
      <path fill="#e70013" d="M0-20h1000v125H0z" />
      <path
        fill="#fff"
        d="M544.2 185.8a54.3 54.3 0 1 0 0 88.4 62.5 62.5 0 1 1 0-88.4M530.4 230l84.1-27.3-52 71.5v-88.4l52 71.5z"
      />
    </g>
  </svg>
);
export default SvgLy;
